import {isArray, isEmpty, isObject, mapValues, set} from 'lodash'
import {SubmissionError} from 'redux-form'

export const getNestedErrors = (data, path = '', res = {}) => {
  if (!isObject(data)) {
    return {}
  }
  Object.entries(data).forEach(([key, value]) => {
    if (key === '_errors') {
      set(
        res,
        path.slice(1),
        mapValues(value, (v) => (isArray(v) ? v[0] : v))
      )
    } else if (isArray(value)) {
      value.forEach((v, index) => getNestedErrors(v, `${path}.${key}[${index}]`, res))
    } else if (isObject(value)) {
      getNestedErrors(value, `${path}.${key}`, res)
    }
  })
  return res
}

export const getBaseErrors = function* (data) {
  if (isArray(data)) {
    for (const v of data) {
      yield* getBaseErrors(v)
    }
    return
  }
  if (!isObject(data)) {
    return
  }
  for (const [key, value] of Object.entries(data)) {
    if (key === '_base') {
      if (isArray(value)) {
        yield* value
      } else {
        yield value
      }
    } else {
      yield* getBaseErrors(value)
    }
  }
}

export const handlerNestFormResponse = (path) => (err) => {
  if (!err.response) {
    throw err
  }
  if (!getBaseErrors(err.response.data).next().done) {
    throw err
  }
  if (err.response && err.response.status === 422) {
    const data = err.response.data
    const errors = getNestedErrors(set({}, path, data))
    if (!isEmpty(errors)) {
      throw new SubmissionError(errors)
    }
  }
  throw err
}

// 上の関数を弄って、リスクが高くなるので、下の関数を使う
export const processValue = (data) => {
  if (isArray(data)) {
    for (const item of data) {
      const key = Object.keys(item)[0]
      const value = item[key]
      const splitKey = key.split('.')

      if (key === 'residence_card') {
        return {visa_history: {residence_card: value[0]}}
      } else {
        return splitKey.reduceRight((acc, k) => ({[k]: acc}), value[0])
      }
    }
  }

  const key = Object.keys(data)[0]
  const value = data[key]
  const splitKey = key.split('.')

  if (key.startsWith('employee.')) {
    return {[splitKey[1]]: value[0]}
  } else if (key === 'procedure_change_address') {
    return {residence_card: value[0]}
  } else if (key === 'icon') {
    return {icon: value[0]}
  } else if (key === 'child_support_allowance_file_name') {
    return {employee_dependents_in_single: {[`${key}`]: value[0]}}
  } else if (key.startsWith('employees_custom_values.')) {
    return {custom_fields: {[`field_${splitKey[2]}`]: value[0]}}
  } else {
    return splitKey.reduceRight((acc, k) => ({[k]: acc}), value[0])
  }
}

export const processError = (err) => {
  if (!err.response) {
    throw err
  }
  if (!getBaseErrors(err.response.data).next().done) {
    throw err
  }
  if (err.response && err.response.status === 422) {
    const data = isArray(err.response.data) ? err.response.data.map((item) => item._errors) : err.response.data._errors
    const errors = processValue(data)

    if (!isEmpty(errors)) {
      throw new SubmissionError(errors)
    }
  }
  throw err
}

export const processResumesError = (obj) => {
  const firstEffectiveErrorDataIndex = obj.resumes.findIndex((item) => item && Object.keys(item).length > 0)
  const resumesError = {
    resumes: {
      file: `${firstEffectiveErrorDataIndex + 1}番目の` + obj.resumes[firstEffectiveErrorDataIndex].file,
    },
  }
  return resumesError
}
